import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Tag } from 'lucide-react';
import AnimatedSection from '../components/AnimatedSection';
import './Blog.css';

const categories = ['All', 'Construction Tips', 'Cost Guides', 'Design Inspiration', 'Home Loans', 'Customer Stories'];

const posts = [
  { id: 1, title: 'How Much Does It Really Cost to Build a House in Bangalore in 2025?', excerpt: 'We break down the actual costs - from land preparation to finishing - so you know exactly what to expect. No sugarcoating.', category: 'Cost Guides', date: 'Mar 15, 2025', readTime: '8 min', img: '/screenshots/dashboard.png' },
  { id: 2, title: '7 Mistakes First-Time Home Builders Make (And How to Avoid Them)', excerpt: 'From choosing the cheapest contractor to not having a complete plan - here are the most common mistakes and how Sculpit helps you avoid them.', category: 'Construction Tips', date: 'Mar 10, 2025', readTime: '6 min', img: '/screenshots/progress.png' },
  { id: 3, title: 'Vastu-Compliant Home Design: What You Actually Need to Know', excerpt: 'Separate the science from the superstition. A practical guide to Vastu principles that actually matter in modern home design.', category: 'Design Inspiration', date: 'Mar 5, 2025', readTime: '5 min', img: '/screenshots/design-studio.png' },
  { id: 4, title: 'Construction Home Loans in India: A Complete Guide for 2025', excerpt: 'Which banks offer the best rates? What documents do you need? How long does approval take? Everything you need to know.', category: 'Home Loans', date: 'Feb 28, 2025', readTime: '10 min', img: '/screenshots/loans.png' },
  { id: 5, title: 'How the Patels Built Their Dream Home in 9 Months with Sculpit', excerpt: 'From a ₹42 lakh budget to moving in on schedule - here\'s how one family used Sculpit to build their 3BHK home in Pune.', category: 'Customer Stories', date: 'Feb 20, 2025', readTime: '7 min', img: '/screenshots/landing.png' },
  { id: 6, title: 'Understanding Construction Milestones: From Foundation to Finishing', excerpt: 'What happens at each stage of construction? When should you pay? What should you inspect? A visual guide.', category: 'Construction Tips', date: 'Feb 15, 2025', readTime: '9 min', img: '/screenshots/progress.png' },
  { id: 7, title: '3D Home Design: Why You Should See Your House Before Building It', excerpt: 'How 3D visualization prevents costly mistakes and helps you make better decisions before a single brick is laid.', category: 'Design Inspiration', date: 'Feb 10, 2025', readTime: '5 min', img: '/screenshots/design-studio.png' },
  { id: 8, title: 'Hidden Costs in Indian Home Construction Nobody Talks About', excerpt: 'Boring wells, compound walls, drainage, government fees - the costs that catch every first-time builder off guard.', category: 'Cost Guides', date: 'Feb 5, 2025', readTime: '8 min', img: '/screenshots/dashboard.png' },
  { id: 9, title: 'How Escrow Payments Protect Homeowners from Contractor Fraud', excerpt: 'Why milestone-based escrow is the safest way to pay for construction - and how Sculpit makes it simple.', category: 'Construction Tips', date: 'Jan 28, 2025', readTime: '6 min', img: '/screenshots/loans.png' },
];

export default function Blog() {
  const [active, setActive] = useState('All');
  const filtered = active === 'All' ? posts : posts.filter(p => p.category === active);

  return (
    <div className="blog-page">
      <section className="blog-hero section-dark">
        <div className="blog-hero__bg"><div className="blog-hero__orb" /></div>
        <div className="container blog-hero__content">
          <AnimatedSection>
            <span className="label label-teal">Sculpit Blog</span>
            <h1>Insights for <span className="text-gradient">Smarter Home Building</span></h1>
            <p className="blog-hero__subtitle">
              Real advice, real numbers, real stories. Everything you need to know about building a house in India.
            </p>
          </AnimatedSection>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="blog-categories">
            {categories.map(cat => (
              <button
                key={cat}
                className={`blog-cat-btn ${active === cat ? 'blog-cat-btn--active' : ''}`}
                onClick={() => setActive(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="blog-grid">
            {filtered.map((post, i) => (
              <AnimatedSection key={post.id} delay={i * 0.08}>
                <article className="blog-card">
                  <div className="blog-card__img">
                    <img src={post.img} alt={post.title} />
                    <span className="blog-card__category"><Tag size={12} /> {post.category}</span>
                  </div>
                  <div className="blog-card__body">
                    <h3>{post.title}</h3>
                    <p>{post.excerpt}</p>
                    <div className="blog-card__meta">
                      <span>{post.date}</span>
                      <span><Clock size={12} /> {post.readTime}</span>
                    </div>
                    <Link to={`/blog/${post.id}`} className="blog-card__link">
                      Read More <ArrowRight size={16} />
                    </Link>
                  </div>
                </article>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-gray" style={{ textAlign: 'center' }}>
        <div className="container">
          <AnimatedSection>
            <h2>Ready to Build Your Dream Home?</h2>
            <p className="cta-subtitle">
              Stop reading about it, start designing it.
            </p>
            <Link to="/pricing" className="btn btn-primary btn-lg">
              Start Designing Free <ArrowRight size={16} />
            </Link>
          </AnimatedSection>
        </div>
      </section>
    </div>
  );
}
